const appConfig = {
  endPoints: {
    api_contact: process.env.REACT_APP_API_CONTACT ? process.env.REACT_APP_API_CONTACT : '',
    api_travel: process.env.REACT_APP_API_TRAVEL ? process.env.REACT_APP_API_TRAVEL : '',
    api_payment: process.env.REACT_APP_API_PAYMENT ? process.env.REACT_APP_API_PAYMENT : ''
  },
  appInsightsKey: process.env.REACT_APP_INSIGHTS_KEY
};

export default appConfig;